import User from "../../entities/user";

/**
 * User actions
 *
 * Call order:
 *
 * USER_SAVE_QUEUE:	adds the item to the save queue
 * --> USER_SAVE:	modifies the state
 * --> USER_SAVE_SUCCESS: if all went well
 * --> USER_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail USER_SAVE_QUEUE is during the call to USER_SAVE,
 * as adding an item to the queue should never fail.
 */

export const USER_FETCH_ONE_QUEUE: any = 'USER_FETCH_ONE_QUEUE';
export const USER_FETCH_SUCCESS: any = 'USER_FETCH_SUCCESS';
export const USER_FETCH_FAILURE: any = 'USER_FETCH_FAILURE';
export const USER_FETCH_ONE_SUCCESS: any = 'USER_FETCH_ONE_SUCCESS';
export const USER_FETCH_ONE_FAILURE: any = 'USER_FETCH_ONE_FAILURE';

export const USER_SAVE: any = 'USER_SAVE';
export const USER_SAVE_QUEUE: any = 'USER_SAVE_QUEUE';
export const USER_SAVE_SUCCESS: any = 'USER_SAVE_SUCCESS';
export const USER_SAVE_FAILURE: any = 'USER_SAVE_FAILURE';

export const USER_SAVE_MANY: any = 'USER_SAVE_MANY';
export const USER_SAVE_MANY_QUEUE: any = 'USER_SAVE_MANY_QUEUE';
export const USER_SAVE_MANY_SUCCESS: any = 'USER_SAVE_MANY_SUCCESS';
export const USER_SAVE_MANY_FAILURE: any = 'USER_SAVE_MANY_FAILURE';

export const USER_REMOVE: any = 'USER_REMOVE';
export const USER_REMOVE_QUEUE: any = 'USER_REMOVE_QUEUE';
export const USER_REMOVE_SUCCESS: any = 'USER_REMOVE_SUCCESS';
export const USER_REMOVE_FAILURE: any = 'USER_REMOVE_FAILURE';

export const USER_RESTORE: any = 'USER_RESTORE';
export const USER_RESTORE_QUEUE: any = 'USER_RESTORE_QUEUE';
export const USER_RESTORE_SUCCESS: any = 'USER_RESTORE_SUCCESS';
export const USER_RESTORE_FAILURE: any = 'USER_RESTORE_FAILURE';

export const USER_RESTORE_MANY: any = 'USER_RESTORE_MANY';
export const USER_REMOVE_MANY: any = 'USER_REMOVE_MANY';

/* Fetch actions */
export const fetchUserSuccess = (users: User[], partial: boolean, lastFetch: number) => ({type: USER_FETCH_SUCCESS, users, partial, lastFetch});
export const fetchUserFailure = (err: any) => {
		console.error('UserAction: fetchUserFailure', err);
		return {type: USER_FETCH_FAILURE, err};
};
export const fetchOneUserQueue = (userId: string) => ({type: USER_FETCH_ONE_QUEUE, userId});
export const fetchOneUserSuccess = (user: User) => ({type: USER_FETCH_ONE_SUCCESS, user});
export const fetchOneUserFailure = (id: string, err: any) => {
		console.error('UserAction: fetchOneUserFailure', err);
		return {type: USER_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveUser = (user: User) => {
    // console.debug('⮂ USER_SAVE action', user?.id);
    return {type: USER_SAVE, user};
}
export const saveUserQueue = (user: User, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ USER_SAVE_QUEUE action', user?.id);
    return {type: USER_SAVE_QUEUE, user, onQueued};
}
export const saveUserSuccess = (user: User) => {
    // console.debug('⮂ USER_SAVE_SUCCESS action', user?.id);
    return {type: USER_SAVE_SUCCESS, user};
}
export const saveUserFailure = (user: User, status: number, message: string) => {
    console.warn(`⮂ USER_SAVE_FAILURE error saving user: HTTP ${status}: ${message}`, user?.id);
    return {type: USER_SAVE_FAILURE, user, status, message};
};

/* SaveMany actions */
export const saveManyUsers = (users: User[]) => {
    // console.debug('⮂ USER_SAVE_MANY action', users?.map(user => user?.id).join(','));
    return {type: USER_SAVE_MANY, users};
}
export const saveManyUsersQueue = (users: User[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ USER_SAVE_MANY_QUEUE action', users?.map(user => user.id).join(','));
    return {type: USER_SAVE_MANY_QUEUE, users, onQueued};
}

export const saveManyUsersSuccess = (users: User[]) => {
    // console.debug('⮂ USER_SAVE_MANY_SUCCESS action', users?.map(user => user.id).join(','));
    return {type: USER_SAVE_MANY_SUCCESS, users};
}
export const saveManyUsersFailure = (users: User[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_USERS_FAILURE Error saving users: HTTP ${status}: ${message}`, users?.map(user => user.id).join(','));
		return {type: USER_SAVE_MANY_FAILURE, users, status, message};
};

/* Remove actions */
export const removeUser = (user: User) => ({ type: USER_REMOVE, user });
export const removeUserQueue = (user: User) => ({ type: USER_REMOVE_QUEUE, user });
export const removeUserSuccess = (user: User) => ({ type: USER_REMOVE_SUCCESS, user });
export const removeUserFailure = (user: User, status: number, message: string) => {
	console.error(`Redux: removeUserFailure Error removing user: HTTP ${status}: ${message}`);
	return ({ type: USER_REMOVE_FAILURE, user, status, message });
};

/* Restore actions */
export const restoreUser = (user: User) => ({ type: USER_RESTORE, user });
export const restoreUserQueue = (user: User) => ({ type: USER_RESTORE_QUEUE, user });
export const restoreUserSuccess = (user: User) => ({ type: USER_RESTORE_SUCCESS, user });
export const restoreUserFailure = (user: User, status: number, message: string) => {
	console.error(`Redux: restoreUserFailure Error restoring user: HTTP ${status}: ${message}`);
	return ({ type: USER_RESTORE_FAILURE, user, status, message });
};

/* RestoreMany actions */
export const restoreManyUsers = (users: User[]) => ({ type: USER_RESTORE_MANY, users });

/* RemoveMany actions */
export const removeManyUsers = (users: User[]) => ({ type: USER_REMOVE_MANY, users });